export default __webpack_public_path__ + "static/media/img_track.9252949c.png";